import React, {useState,useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import {useAuth} from "./../contextos/AuthContext"
import {Formulario, Input, Etiqueta, ContenedorBoton, ContenedorSelect, ContenedorGrupoSelect} from '../elementos/ElementosDeFormulario'
import Boton from '../elementos/Boton'
import SelectTipoUsuarios from './SelectTipoUsuarios';
import Api from '../servicios/api';
import Alerta from '../elementos/Alerta'


const FormularioUsuario = ({usuario}) => {
    const {idUsuario, setNombresUsuario} = useAuth();
    const [inputNombre, setInputNombre] = useState('');
    const [inputCorreo, setInputCorreo] = useState('');
    const [inputPassword, setInputPassword] = useState('');
    const [selectTipoUsuario, setSelectTipoUsuario] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const navigate = useNavigate();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        if(usuario){
            setInputNombre(usuario.Usu_Nombres);
            setInputCorreo(usuario.Usu_Correo);
            setSelectTipoUsuario({Tip_ID:usuario.Tip_ID, Tip_Descripcion:usuario.Tip_Descripcion});
        }
    }, [usuario]);

    const handleChange = (e) => {
        switch(e.target.name){
            case 'nombres':
                setInputNombre(e.target.value);
                break;
            case 'email':
                setInputCorreo(e.target.value);
                break;
            case 'password':
                setInputPassword(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setEstadoAlerta(false);
        setAlerta({});

        // Validaciones del lado del cliente para que los inputs no esten vacios
        if(!usuario){
            if(inputPassword === ''){
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'error',
                    mensaje: 'Por favor rellena todos los datos'
                });
                return;
            }
        }

        if(inputNombre === '' || inputCorreo === '' || selectTipoUsuario.Tip_ID === 0){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los datos'
            });
            return;
        }

        // Comprobamos del lado del cliente para que el correo sea valido
        const expresionRegular = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
        if( !expresionRegular.test(inputCorreo) ){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'Por favor ingresa un correo electrónico válido'
            });
            return;
        }

        var datosEnviar;
        if(!usuario){
            datosEnviar = {nombres:inputNombre, correo:inputCorreo, password:inputPassword, idTipoUsuario:selectTipoUsuario.Tip_ID}
            
            fetch(Api+"?insertarUsuario=1",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                if(datosRespuesta.success === 1){
                    setInputNombre('');
                    setInputCorreo('');
                    setInputPassword('');
                    setSelectTipoUsuario({Tip_ID:0, Tip_Descripcion: 'Seleccione un tipo de usuario'});
                    setEstadoAlerta(true);
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'exito',
                        mensaje: 'Usuario registrado correctamente.'
                    });
                }
                else{
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'error',
                        mensaje: 'No es posible registrar este usuario.'
                    });
                }
            })
            .catch(console.log)
        }

        else{
            datosEnviar = {id:usuario.Usu_ID, nombre:inputNombre, correo:inputCorreo, idTipoUsuario:selectTipoUsuario.Tip_ID}

            fetch(Api+"?actualizarUsuario=1",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                if(idUsuario === usuario.Usu_ID){
                    setNombresUsuario(inputNombre)
                }
                navigate("/usuarios");
            })
            .catch(console.log)
        }
    }

    return (
        <>
            <Formulario onSubmit={handleSubmit}>
                <div>
                    <Etiqueta htmlFor="">Nombres</Etiqueta>
                    <Input
                        type="text"
                        name="nombres"
                        placeholder="Nombres y Apellidos"
                        value={inputNombre}
                        onChange={handleChange}
                    />
                    <Etiqueta htmlFor="">Correo electrónico</Etiqueta>
                    <Input
                        type="email"
                        name="email"
                        placeholder="Correo electrónico"
                        value={inputCorreo}
                        onChange={handleChange}
                    />

                    {!usuario ? 
                    <>
                    <Etiqueta htmlFor="">Contraseña</Etiqueta>
                    <Input
                        type="password"
                        name="password"
                        placeholder="Contraseña"
                        value={inputPassword}
                        onChange={handleChange}
                    />
                    </> 
                    : 
                    <></>
                    }
                </div>

                <ContenedorGrupoSelect>
                    <ContenedorSelect>
                        <Etiqueta htmlFor="">Tipo de Usuario</Etiqueta>
                        <SelectTipoUsuarios
                            selectTipoUsuario={selectTipoUsuario}
                            setSelectTipoUsuario={setSelectTipoUsuario}
                        />
                    </ContenedorSelect>
                </ContenedorGrupoSelect>

                <ContenedorBoton>
                        <Boton to="/usuarios">Cancelar</Boton>
                        <Boton as="button" type="submit" primario="true">
                            {usuario ? 'Actualizar' : 'Guardar'} 
                        </Boton>
                </ContenedorBoton>
            </Formulario>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setEstadoAlerta={setEstadoAlerta}
            />
        </>
    );
}
 
export default FormularioUsuario;